import { render } from "./ScoreNumberOnly.vue?vue&type=template&id=5dcb2ce7&scoped=true&ts=true"
import script from "./ScoreNumberOnly.ts?vue&type=script&lang=ts&external"
export * from "./ScoreNumberOnly.ts?vue&type=script&lang=ts&external"

import "./ScoreNumberOnly.scss?vue&type=style&index=0&id=5dcb2ce7&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcb2ce7"]])

export default __exports__